<template>
  <v-container class="py-12">
    <v-row>
      <v-col
        cols="12"
        lg="6"
        md="6"
        sm="12"
        v-for="(item, index) in projSelect"
        :key="index"
      >
        <v-card outlined>
          <v-img height="400px" :src="require(`../../assets/${item.imgsrc}`)">
          </v-img>
          <v-card-title class="subtitle-1">{{$t(`project.${item.title}`)}}</v-card-title>
          <v-card-subtitle class="pb-0">
            {{ item.date }}
          </v-card-subtitle>

          <v-card-text class="text--primary pt-2 caption">
            <div>{{$t(`project.${item.description}`)}}</div>
          </v-card-text>

          <v-card-actions class="pa-4">
            <v-btn outlined color="primary" text :to="`/projectInfo=${prop}&${imgsrc}&${JSON.stringify(item)}`">
              {{$t('readmore')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import json from "../../data/projects.json";
export default {
  props: ["prop", "imgsrc"],
  data() {
    return {
      projects: json,
      projSelect:[]
    };
  },
  created() {
      if (this.prop == "Roads") {
        this.projSelect = this.projects.projects.Roads
      }else if (this.prop == "Bridges") {
        this.projSelect = this.projects.projects.Bridges
      }else if (this.prop == "Filtering Station") {
        this.projSelect = this.projects.projects.FilteringStation
      }else if (this.prop == "Water Treatment") {
        this.projSelect = this.projects.projects.WaterTreatment
      }else if (this.prop == "Housing Complexes") {
        this.projSelect = this.projects.projects.HousingComplexes
      }else if (this.prop == "Shopping Center") {
        this.projSelect = this.projects.projects.ShoppingCenter
      }else if (this.prop == "Design") {
        this.projSelect = this.projects.projects.Design
      }else if (this.prop == "Parks") {
        this.projSelect = this.projects.projects.Parks
      }else if (this.prop == "Telecommunications") {
        this.projSelect = this.projects.projects.Telecommunications
      }else if (this.prop == "Universities") {
        this.projSelect = this.projects.projects.Universities
      }else if (this.prop == "Airports") {
        this.projSelect = this.projects.projects.Airports
      }else if (this.prop == "Hospitals") {
        this.projSelect = this.projects.projects.Hospitals
      }
  },
  methods: {
 
  },
};
</script>

<style></style>
